module.exports = __webpack_public_path__ + "img/addToAppleWallet_cs.7184852c.svg";